<template>
  <action-dispatcher
    action="lessons/getNotations"
    class="d-flex flex-column h-100"
    :parameters="$route.params.lesson"
    @success="success"
  >
    <form class="tab-lesson-notations-component pt-2" @submit.prevent="save">
      <div v-if="!notations.length" class="text-center pt-4">
        <small class="text-secondary">
          Você ainda não adicionou nenhuma nota
        </small>
      </div>
      <div class="notations-list custom-thin-scrollbar flex-fill mb-2">
        <div
          v-for="(note, i) in notations"
          :key="`note-${i}`"
          class="notation-item p-2 mb-2"
          @click="seekTo(note)"
        >
          <div class="d-flex align-items-start">
            <div class="flex-fill duration">
              <small> {{ formatDuration(note.current_lesson_duration) }}</small>
            </div>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none menu-icon btn-sm p-0"
              no-caret
              left
            >
              <template #button-content>
                <i class="icon-options text-secondary"></i>
              </template>
              <b-dropdown-item
                @click="edit(note)"
                link-class="d-item font-weight-normal"
              >
                <i class="fa-solid fa-pen text-dark"></i> Editar nota
              </b-dropdown-item>
              <b-dropdown-item
                @click="remove(note)"
                link-class="d-item font-weight-normal"
              >
                <i class="fa-solid fa-trash text-dark"></i> Apagar nota
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <span class="note-content">
            {{ note.text }}
          </span>
        </div>
      </div>
      <div class="form-group d-flex align-items-center pr-2">
        <input
          type="text"
          v-model="text"
          class="form-control flex-fill"
          placeholder="Nova anotação...."
          @input="$emit('pause')"
          @blur="$emit('play')"
        />
        <button class="btn text-primary btn-sm" type="submit">
          <b-spinner v-if="loading" small class="my-1" />
          <span v-else>Salvar</span>
        </button>
      </div>

      <b-modal
        v-model="editing"
        :modal-class="`theme-${$setup.theme}-modals`"
        size="md"
        scrollable
        hide-footer
        hide-header
        centered
      >
        <div class="edit-note-modal">
          <h6 class="text-center mb-4">Editar nota</h6>
          <button class="btn icon-close" @click="cancelEdit" />
          <div v-if="edited_note" class="form-group mb-4">
            <textarea
              type="text"
              v-model="edited_note.text"
              class="form-control flex-fill"
              placeholder="Nova anotação...."
            >
            </textarea>
          </div>
          <div class="d-flex align-items-center justify-content-end">
            <button class="btn btn-outline-secondary mr-4" @click="cancelEdit">
              Cancelar
            </button>
            <button class="btn btn-primary" type="button" @click="save">
              <b-spinner v-if="loading" small />
              <span v-else>Salvar</span>
            </button>
          </div>
        </div>
      </b-modal>
    </form>
  </action-dispatcher>
</template>
<script>
import { duration_seconds_to_humanized } from "@/functions/helpers";
export default {
  props: {
    lesson: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      notations: [],
      edited_note: null,
      editing: false,
      loading: false,
      text: ""
    };
  },
  methods: {
    success({ results }) {
      this.notations = results;
    },
    formatDuration(duration) {
      return duration_seconds_to_humanized(duration);
    },
    seekTo(note) {
      if (window.player) {
        window.player.currentTime = note.current_lesson_duration;
      }
    },
    async save() {
      try {
        this.loading = true;

        if (this.edited_note) {
          if (!this.edited_note.text || this.edited_note.text.length == 0) {
            this.$message.warning("Digite o texto da sua anotação");
            return;
          }
          await this.$store.dispatch("lessons/putNotations", this.edited_note);
          this.edited_note = null;
          this.editing = false;
        } else {
          if (!this.text || this.text.length == 0) {
            this.$message.warning("Digite o texto da sua anotação");
            return;
          }

          let current_lesson_duration = 0;
          if (window.player) {
            current_lesson_duration = window.player.currentTime;
          }
          const payload = {
            lesson: this.$route.params.lesson,
            current_lesson_duration: parseInt(current_lesson_duration),
            text: this.text
          };
          await this.$store.dispatch("lessons/postNotations", payload);
        }

        this.text = "";
        await this.$store
          .dispatch("lessons/getNotations", this.$route.params.lesson)
          .then(this.success);
      } catch (e) {
        this.$message.error("Não foi possível salvar sua anotação.");
      } finally {
        this.loading = false;
      }
    },
    edit(note) {
      this.edited_note = { ...note };
      this.editing = true;
    },
    cancelEdit() {
      this.edited_note = null;
      this.editing = false;
    },
    async remove(note) {
      await this.$store.dispatch("lessons/deleteNotations", note.id).then();
      await this.$store
        .dispatch("lessons/getNotations", this.$route.params.lesson)
        .then(this.success);
    }
  }
};
</script>
<style lang="scss" scoped>
.tab-lesson-notations-component {
  display: flex;
  flex-direction: column;
  height: -webkit-fill-available;

  .notations-list {
    overflow-y: scroll;
    height: 100px;
    @media screen and (max-width: 991px) {
      height: 300px;
    }
  }

  .form-group {
    border-radius: 10px;
    .form-control {
      background: transparent !important;
      box-shadow: none;
      outline: none;
      border: none !important;
      height: 100%;
      resize: none;
    }
  }

  .duration {
    font-style: normal;
    line-height: 150%;
    font-weight: 400;
  }
  .notation-item {
    cursor: pointer;
    font-size: 14px;
    border-radius: 4px;
    line-break: anywhere;
    small {
      font-size: 12px;
    }
    .note-content {
      font-size: 14px;
      font-weight: 400;
      line-height: 150%;
    }
  }

  .icon-close {
    position: absolute;
    top: 2%;
    right: 0%;
  }

  ::v-deep .dropdown-menu {
    box-shadow: none !important;
    border: none !important;
    background: #fff !important;
    top: -35px !important;
    left: -30px !important;
  }

  .d-item,
  .dropdown-menu .dropdown-item {
    font-weight: 400 !important;
    font-size: 14px !important;
    i {
      color: #000 !important;
      font-size: 14px;
    }

    .dropdown-toggle {
      padding: 0;
      min-height: 5px;
      min-width: 5px;
    }
  }
}
</style>
